export default __webpack_public_path__ + "static/media/picto_circ_court.2f1557a9.png";